export { default } from './ProductCard';
export { coverAspectFor, COVER_ASPECT } from './coverAspect';
export type { CoverAspect } from './coverAspect';
